"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableNavItem = ExpandableNavItem;
exports.NavItem = NavItem;
exports.NavItemContainer = exports.IconContainer = exports.NavItemsContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CollapseIcon = _interopRequireDefault(require("./CollapseIcon"));

var _DefaultNavIcon = _interopRequireDefault(require("./DefaultNavIcon"));

var _ExpandIcon = _interopRequireDefault(require("./ExpandIcon"));

var _excluded = ["children", "to", "label", "icon", "expand"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NavItemsContainer = _styledComponents["default"].ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\ndisplay: grid;\ngrid-auto-flow: row;\ngap: 0.15rem;\nlist-style-type: none;\npadding: 0.5rem .5rem .5rem 0rem;\ntransition: padding var(----transition-settings-1, 0.2s ease);\n"])));

exports.NavItemsContainer = NavItemsContainer;

var IconContainer = _styledComponents["default"].picture(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\ndisplay: inline-grid;\nplace-items: center;\nwidth: var(--icon-container-size, 1.75rem);\nheight: var(--icon-container-size, 1.75rem);\nmargin-left: 0.5rem;\nmargin-right: 1rem;\n"])));

exports.IconContainer = IconContainer;

var NavItemContainer = _styledComponents["default"].li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\nspan {\nwhite-space: nowrap;\noverflow: hidden;\n}\n\na {\n    padding: 0.15rem 1rem 0.15rem 0rem;\n    margin-top: 0.25rem;\n    border-radius: 0.5rem;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    color: inherit;\n    text-decoration: none;\n    transition: background var(--transition-settings-1, 0.2s ease);\n    cursor: pointer;\n\n    span {\n        opacity: 0;\n        transition: opacity var(--transition-settings-1, 0.2s ease);\n    }\n}\na.active {\n    ", " {\n        background: var(--primary-accent, #009688);\n        color: var(--on-primary-accent, #FFF);\n        border-radius: 50%;\n    }\n}\n"])), IconContainer);

exports.NavItemContainer = NavItemContainer;
var delayOverflow = (0, _styledComponents.keyframes)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\nfrom {\n    overflow-y: auto;\n}\n"])));

var ExpandableContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\noverflow-y: auto;\ntransition: height var(--transition-settings-1, 0.2s ease);\n\n&.overflow {\n    overflow-y: visible;\n    animation: ", " 0.5s;\n}\n"])), delayOverflow);

function ExpandableNavItem(_ref) {
  var children = _ref.children,
      label = _ref.label,
      expand = _ref.expand;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var content = /*#__PURE__*/(0, _react.createRef)();
  var isCollapsed = height === 0;

  var expandGroup = function expandGroup() {
    setHeight(content.current.clientHeight);
    typeof expand === 'function' && expand();
  };

  var toggleExpand = function toggleExpand() {
    setHeight(function (prevHeight) {
      if (prevHeight === 0) return content.current.clientHeight;
      return 0;
    });
  };

  return /*#__PURE__*/_react["default"].createElement(NavItemContainer, null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: toggleExpand
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, null, isCollapsed ? /*#__PURE__*/_react["default"].createElement(_ExpandIcon["default"], {
    width: "0.75rem"
  }) : /*#__PURE__*/_react["default"].createElement(_CollapseIcon["default"], {
    width: "0.75rem"
  })), /*#__PURE__*/_react["default"].createElement("span", null, label)), /*#__PURE__*/_react["default"].createElement(ExpandableContainer, {
    className: !isCollapsed && 'overflow',
    style: {
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(NavItemsContainer, {
    ref: content
  }, _react.Children.map(children, function (child) {
    var props = child.props;
    return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, props), {}, {
      expand: expandGroup
    }));
  }))));
}

var scrollElementIntoViewAfterDelay = function scrollElementIntoViewAfterDelay(element) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  setTimeout(function () {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }, delay);
};

function NavItem(_ref2) {
  var children = _ref2.children,
      to = _ref2.to,
      label = _ref2.label,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? /*#__PURE__*/_react["default"].createElement(_DefaultNavIcon["default"], {
    width: "0.75rem"
  }) : _ref2$icon,
      expand = _ref2.expand,
      props = _objectWithoutProperties(_ref2, _excluded);

  var item = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    try {
      if (!children && window.location.pathname === to) {
        typeof expand === 'function' && expand();
        scrollElementIntoViewAfterDelay(item.current);
      }
    } catch (ex) {
      console.error('Cannot expand and scroll to nav link', ex);
    }
  }, []);
  if (children) return /*#__PURE__*/_react["default"].createElement(ExpandableNavItem, {
    expand: expand,
    label: label
  }, children);
  return /*#__PURE__*/_react["default"].createElement(NavItemContainer, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, _extends({
    ref: item,
    to: to,
    activeClassName: "active"
  }, props), /*#__PURE__*/_react["default"].createElement(IconContainer, null, icon), /*#__PURE__*/_react["default"].createElement("span", null, label)));
}